module.exports = __webpack_public_path__ + "1c01aa0ca4483e43d6bcbc7a9d017a02.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/captain-million.png
// module id = ./assets/thumbnails/captain-million.png
// module chunks = 2